<template>
    <aside class="aside">
        <slot></slot>
    </aside>
</template>

<script>
export default {};
</script>
